// C(2) Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Blake", location: "TX", product: "C(2) 2 Bottles", time: "12 minutes ago" },
    { name: "Cesar", location: "Costa Rica", product: "C(2) 4 Bottles", time: "19 minutes ago" },
    { name: "Christopher", location: "MI", product: "C(2) 1 Bottle", time: "27 minutes ago" },
    { name: "Rosie", location: "CA", product: "C(2) 1 Bottle", time: "35 minutes ago" },
    { name: "Carolina", location: "FL", product: "C(2) 1 Bottle", time: "42 minutes ago" },
    { name: "Kelly", location: "MO", product: "C(2) 1 Bottle", time: "51 minutes ago" },
    { name: "Craig", location: "CT", product: "C(2) 2 Bottles", time: "59 minutes ago" },
    { name: "Juan", location: "IL", product: "C(2) 1 Bottle", time: "1 hour 8 minutes ago" },
    { name: "Alejandro", location: "CA", product: "C(2) 1 Bottle", time: "1 hour 17 minutes ago" },
    { name: "Frank", location: "DE", product: "C(2) 1 Bottle", time: "1 hour 27 minutes ago" },
    { name: "Joana", location: "CA", product: "C(2) 1 Bottle", time: "13 minutes ago" },
    { name: "DJ", location: "VA", product: "C(2) 1 Bottle", time: "22 minutes ago" },
    { name: "Albert", location: "CA", product: "C(2) 1 Bottle", time: "31 minutes ago" },
    { name: "James", location: "TX", product: "C(2) 1 Bottle", time: "41 minutes ago" },
    { name: "Reggie", location: "AR", product: "C(2) 1 Bottle", time: "52 minutes ago" },
    { name: "Dylan", location: "WA", product: "C(2) 1 Bottle", time: "15 minutes ago" },
    { name: "Qioni", location: "GA", product: "C(2) 1 Bottle", time: "28 minutes ago" },
    { name: "Omar", location: "CA", product: "C(2) 1 Bottle", time: "39 minutes ago" },
    { name: "Kevin", location: "PA", product: "C(2) 1 Bottle", time: "49 minutes ago" },
    { name: "Jeff", location: "GA", product: "C(2) 2 Bottles", time: "1 hour 3 minutes ago" },
    { name: "Dave", location: "IN", product: "C(2) 4 Bottles", time: "14 minutes ago" },
    { name: "Ty", location: "WA", product: "C(2) 1 Bottle", time: "29 minutes ago" },
    { name: "Frank", location: "CA", product: "C(2) 1 Bottle", time: "45 minutes ago" },
    { name: "Orlando", location: "PA", product: "C(2) 1 Bottle", time: "1 hour 2 minutes ago" },
    { name: "Abdulrahim", location: "CA", product: "C(2) 2 Bottles", time: "1 hour 19 minutes ago" },
    { name: "Sean", location: "WI", product: "C(2) 1 Bottle", time: "16 minutes ago" },
    { name: "Christiana", location: "CA", product: "C(2) 1 Bottle", time: "33 minutes ago" },
    { name: "Alejandro", location: "CA", product: "C(2) 1 Bottle", time: "48 minutes ago" },
    { name: "Catherine", location: "IL", product: "C(2) 2 Bottles", time: "1 hour 8 minutes ago" },
    { name: "Salvatore", location: "FL", product: "C(2) 1 Bottle", time: "1 hour 25 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/C2_Creapure_Creatine_2_Zoom.png?v=1733425852" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
